export const ipMoodle = "138.68.226.91";
export const baseURL = "https://campus.colegioezer.cl/";
export const tipddytoken = "9d968ec112f1fa836e3e2f23b4789774"; // esta estpa generado a nombre de agu quiroz
export const moodleURL = `${baseURL}webservice/rest/server.php?wstoken=`;
export const iappUrl = "https://tipddy-rnu.iapp.cl/api/rnu";

export const API = {
  dev: "http://localhost:3000/",
  prod: "https://alumnos.tuclase.cl",
};
